import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { NgForm } from '@angular/forms';
import { MessageService } from 'primeng/api';
import { Messages } from '@app/constants/constant';
import { SourceAddEditService } from './source-add.service';

@Component({
  selector: 'app-agency-modal',
  templateUrl: './agency-modal.component.html',
  styleUrls: ['./agency-modal.component.css'],
  providers : [SourceAddEditService]
})
export class AgencyModalComponent implements OnInit {

  showCrossIcon = true;
  editFlag :boolean;
  @Input() display: boolean;
  @Input() sourceTypeOptions: any;
  @Output() displayFunction = new EventEmitter<boolean>();
  @Output() sourceData = new EventEmitter<Object>();
  @Input() searchedSource :any;
  @Input() isEditable :boolean;

  @ViewChild('createSourceForm', { static: false }) public createSourceForm: NgForm;
  sourceCreation:any = {

    selectedSourceType : {
      id : '',
      name : ''
    },
    id : '',
    name : '',
    isActive : true
};

  showCloseIcon(){
    this.showCrossIcon = false;
  };

  constructor(
    private _toastService: MessageService,
    private _apiService : SourceAddEditService
  ) { }

  ngOnInit() {
    this.editFlag = this.display && this.isEditable && this.searchedSource && this.searchedSource.selectedSourceType && this.searchedSource.selectedSource ? true : false;
    if (this.editFlag)
    {
      this.updateForm();
    }
  }

  showDialog(bool: boolean) {
    this.displayFunction.emit(bool);
  }

  createSource() {

    if (this.editFlag){
     
      this._apiService.editSource(this.sourceCreation).subscribe(res =>
        {
        this._toastService.add({ severity: 'success', summary:this.editFlag ? Messages.sourceEdited: Messages.sourceCreatedSuccess, detail: '' });
          this.sourceData.emit(this.sourceCreation);
          this.showDialog(false);
          this.createSourceForm.reset();
      }, (err) => { 
        this._toastService.add({ severity: 'error', summary:this.editFlag ? Messages.sourceEditedError+ " due to "+ err: Messages.sourceCreatedError, detail: err.error });
        this.showDialog(false);
        this.createSourceForm.reset();
        })
    }
    else
    {
        this._apiService.addSource(this.sourceCreation).subscribe(res => {
          this.sourceData.emit(this.sourceCreation);
          this.showDialog(false);
          this.createSourceForm.reset();
          this._toastService.add({ severity: 'success', summary: Messages.sourceCreatedSuccess, detail: '' });
        }, (err) => { 
          this._toastService.add({ severity: 'error', summary: Messages.sourceCreatedError+ " due to "+ err, detail: err.error });
          this.showDialog(false);
          this.createSourceForm.reset();
        });
    }
}

  updateForm()
  {
    if(this.searchedSource && this.searchedSource.selectedSource && this.searchedSource.selectedSourceType)
    {
      this.sourceCreation.name = this.searchedSource.selectedSource.name;
      this.sourceCreation.id = this.searchedSource.selectedSource.id;
      this.sourceCreation.selectedSourceType = this.searchedSource.selectedSourceType;
      this.sourceCreation.isActive = this.searchedSource.selectedSource.isActive;
    }
  }
}
